export default __webpack_public_path__ + "static/media/qa.cf4e4610.png";